<ng-container *ngIf="product as p">
  <ng-container [ngSwitch]="isDesktop">
    <product-details-mobile
      *ngSwitchCase="false"
      [product]="p"
    ></product-details-mobile>
    <product-details-desktop
      *ngSwitchCase="true"
      [product]="p"
    ></product-details-desktop>
  </ng-container>
</ng-container>
